import React from 'react';
import styled from 'styled-components';
import { getInitials, selectTheme } from './AvatarHelper';

export interface IAvatar {
  name: string; //Name is the full name of the person
  type?: 'icon' | 'image';
}

export const AvatarContainer = styled.div<{ type: string }>`
  border-radius: 50%;
  width: ${(props) => (props.type === 'icon' ? '1.75rem' : '2rem')};
  height: ${(props) => (props.type === 'icon' ? '1.75rem' : '2rem')};
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Avatar: React.FC<IAvatar> = ({ name, type = 'image' }) => {
  const initials = getInitials(name);
  const avatarTheme = selectTheme(name);
  return (
    <AvatarContainer
      type={type}
      style={{ background: avatarTheme.background, color: avatarTheme.color }}
    >
      {initials}
    </AvatarContainer>
  );
};

export default Avatar;
